import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const formatCurrency = (amount: number): string => {
  return `EGP ${amount.toFixed(2)}`;
};

export const formatDate = (timestamp: any): string => {
  if (!timestamp) return "-";
  
  // If it's a Firestore Timestamp, convert to Date
  if (timestamp?.toDate) {
    timestamp = timestamp.toDate();
  }
  
  // If it's a string, convert to Date
  if (typeof timestamp === "string") {
    timestamp = new Date(timestamp);
  }

  return new Intl.DateTimeFormat("en-EG", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "Africa/Cairo"
  }).format(timestamp);
};
